<template>
  <div class="page">
    <fieldset>
      <legend>New Items</legend>
      <textarea v-model="newItemDetails" placeholder="Item Details"></textarea>
      <button v-on:click="processItems">Add Items</button>

      <div class="pool-list-container">
        <table class="pool-list">
          <tr>
            <th>English</th>
            <th>Thai</th>
            <!-- <th>Note</th> -->
            <th>Complexity</th>
            <th colspan="2">Order</th>
            <th>Delete</th>
          </tr>
          <tr
            class="pool-list__row"
            v-for="(item, itemIndex) in newItems"
            v-bind:key="item.id"
          >
            <td>
              <EditableItemProperty
                v-bind:item="item"
                v-bind:propertyPath="['properties', 'english', 'value']"
                />
            </td>

            <td @contextmenu.prevent="toggleRowMode(itemIndex)">
              <PhraseDetails
                v-show="!rowModes[itemIndex]"
                v-bind:phrase="item.phrase"
                />
              <EditableItemProperty
                v-show="rowModes[itemIndex]"
                v-bind:item="item"
                v-bind:propertyPath="['properties', 'thai', 'value']"
                />
            </td>

            <td>
              <Promised :promise="item.getComplexity()">
                <div slot="pending">...</div>
                <div slot="rejected" slot-scope="error">{{ error }}</div>
                <div slot-scope="complexity">
                  {{ complexity }}
                </div>
              </Promised>
            </td>

            <td><button class="btn--small" v-on:click="sendToTop(item)">↑</button></td>
            <td><button class="btn--small" v-on:click="sendToBottom(item)">↓</button></td>

            <td>
              <button class="btn--small" v-on:click="deleteItem(item)">╳</button>
            </td>
            
          </tr>
        </table>
      </div>

    </fieldset>

  </div>
</template>

<style lang="scss">
table {
  border-collapse: collapse;
}

.pool-list__row:nth-of-type(odd) td {
  background: rgb(240, 240, 240);
}

.pool-list__row--disabled td {
  background: pink !important;
}
</style>

<script>
import Vue from 'vue';
import { Promised } from 'vue-promised';
Vue.component('Promised', Promised);

import { mapGetters } from 'vuex';

import * as db from '@/libs/db.js';
import EditableItemProperty from '@/components/EditableItemProperty.vue';
import PhraseDetails from '@/components/PhraseDetails.vue';

import splitThaiWords from '@/libs/splitter';

export default {
  name: 'NewItemsManager',
  store: db.store,
  components: {
    Promised,
  },
  data: function() {
    return {
      newItemDetails: '',
      itemComplexity: {},
      rowModes: {},
    }
  },
  components: {
    EditableItemProperty,
    PhraseDetails,
  },
  computed: {
    ...mapGetters(['newItems']),
  },
  methods: {
    toggleRowMode(row) {
      if (this.rowModes[row] === undefined) {
        Vue.set(this.rowModes, row, true);
        return;
      }
      this.rowModes[row] = !this.rowModes[row];
    },
    async processItems() {
      var allItemDetails = this.newItemDetails.split("\n\n");

      var newItems = [];
      for (var i = 0; i < allItemDetails.length; i++) {
        var itemDetails = allItemDetails[i];
        var details = itemDetails.split("\n");
        if (details.length < 2) {
          throw Error(`Not enough fields for item #${i}.`);
        }

        var english, thai;
        if (details[0].charCodeAt(0) <= 255) {
          english = details[0];
          thai = details[1];
        } else {
          english = details[1];
          thai = details[0];
        }

        thai = splitThaiWords(thai).join(" - ");

        let item = db.createItem(english, thai);

        if (details[2] !== undefined) {
          item.properties.note = details[2];
        }

        newItems.push(item);
      }

      await this.$store.dispatch('addItems', newItems);

      this.newItemDetails = "";
      window.alert(`Saved ${newItems.length} new items.`);
    },
    async sendToTop(item) {
      item.sortIndex = -(new Date().getTime());
      await this.$store.dispatch('putItem', item);
    },
    async sendToBottom(item) {
      item.sortIndex = (new Date().getTime());
      await this.$store.dispatch('putItem', item);
    },
    // getComplexity(item) {
    //   return effectivePhraseComplexity(item);
    // },
    async deleteItem(item) {
      await this.$store.dispatch('deleteItem', item.id);
    },

    // saveDbStuff() {
    //   this.$store.dispatch('saveAllItems');
    // }
  },
  mounted() {
    // this.$store.dispatch('init');
  },
}
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
